<div class="unable-to-proceed-dialog">
  <!-- Content -->
  <div class="dialog-content">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ 'unable_to_proceed_dialog.title' | translateLang }}</h2>
      <p class="dialog-message">
        {{ 'unable_to_proceed_dialog.message_prefix' | translateLang }}
        <a [href]="contactUrl" target="_blank" rel="noopener noreferrer" class="support-link">{{ 'unable_to_proceed_dialog.contact_link' | translateLang }}</a>
        {{ 'unable_to_proceed_dialog.message_suffix' | translateLang }}
      </p>
    </div>
    <div class="dialog-buttons">
      <button type="button" class="close-btn" (click)="onClose()">
        {{ 'unable_to_proceed_dialog.close_button' | translateLang }}
      </button>
      <button type="button" class="guest-btn" (click)="onContinueAsGuest()">
        {{ 'unable_to_proceed_dialog.guest_button' | translateLang }}
      </button>
    </div>
  </div>
</div>
